window._paq = window._paq || [];

window._paq.push(['trackPageView']);
window._paq.push(['enableLinkTracking']);
window._paq.push(['setTrackerUrl', 'https://analytics.leaseweb.com/matomo.php']);
window._paq.push(['setSiteId', '1']);

(function() {
  const d = document;
  const g = d.createElement('script');
  const s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';
  g.async = true;
  g.defer = true;
  g.src = 'https://analytics.leaseweb.com/matomo.js';
  s.parentNode.insertBefore(g, s);
})();
